import * as TestimonialsFeaturesUploads from "$lib/data/generated/uploads/testimonials/Features/uploads.js";
import * as TestimonialsPageBannerUploads from "$lib/data/generated/uploads/testimonials/PageBanner/uploads.js";
import * as TestimonialsTestimonialsUploads from "$lib/data/generated/uploads/testimonials/Testimonials/uploads.js";
import * as TestimonialsTestimonialsPageUploads from "$lib/data/generated/uploads/testimonials/TestimonialsPage/uploads.js";

export const uploads = {
  ...TestimonialsFeaturesUploads.uploads,
  ...TestimonialsPageBannerUploads.uploads,
  ...TestimonialsTestimonialsUploads.uploads,
  ...TestimonialsTestimonialsPageUploads.uploads
};
